<template>
  <div>
    <b-alert
      variant="danger"
      :show="errorMessage ? true : false"
    >
      <div class="alert-body">
        <p>
          {{ errorMessage }}
        </p>
      </div>
    </b-alert>
    <b-row>
      <b-col
        cols="12"
        md="3"
      >
        <b-form-group label="Bill Number">
          <b-form-input
            v-model="billNumber"
            type="text"
            placeholder="Search Bill Number"
          />
        </b-form-group>
      </b-col>
      <b-col
        cols="12"
        md="3"
      >
        <b-form-group
          label="Areas"
        >
          <custom-v-select
            v-model="filters.areas"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="areaOptions"
            label="text"
            placeholder="Select Areas"
            multiple
            :disabled="loading"
            :close-on-select="false"
            :reduce="data => data.id"
            :deselect-from-dropdown="true"
          />
        </b-form-group>
      </b-col>
      <b-col
        cols="12"
        md="3"
        class="position-relative"
      >
        <div style="display: flex; position: absolute; gap: 10px; top: 0; right: 12px;">
          <b-form-checkbox
            :checked="filters.buyer_type === 'cash'"
            @change="$emit('input', { ...filters, buyer_type: filters.buyer_type === 'cash' ? '' : 'cash' })"
          >
            Cash
          </b-form-checkbox>
          <b-form-checkbox
            :checked="filters.buyer_type === 'credit'"
            @change="$emit('input', { ...filters, buyer_type: filters.buyer_type === 'credit' ? '' : 'credit' })"
          >
            Credit
          </b-form-checkbox>
        </div>
        <b-form-group label="Buyers">
          <custom-v-select
            v-model="filters.buyers"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="buyerOptions"
            label="text"
            placeholder="Select Buyers"
            multiple
            :disabled="loading"
            :close-on-select="false"
            :reduce="data => data.id"
            :deselect-from-dropdown="true"
          />
        </b-form-group>
      </b-col>
      <b-col
        cols="12"
        md="3"
      >
        <b-form-group label="Status">
          <custom-v-select
            v-model="filters.statuses"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="statusOptions"
            label="text"
            placeholder="Select Status"
            multiple
            :close-on-select="false"
            :deselect-from-dropdown="true"
          />
        </b-form-group>
      </b-col>
      <b-col
        cols="12"
        md="3"
      >
        <b-form-group
          label="Date"
        >
          <flat-picker
            v-model="filters.date"
            placeholder="Select Date Range"
            :config="{ mode: 'range'}"
          />
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group label="Created By">
          <custom-v-select
            v-model="filters.createdBy"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="margUsers"
            label="name"
            placeholder="Select Created By"
            multiple
            :close-on-select="false"
            :deselect-from-dropdown="true"
            :reduce="(data => data.name)"
          />
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group label="Picked By">
          <custom-v-select
            v-model="filters.pickedBy"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="usersList"
            label="fullname"
            placeholder="Select Picked By"
            multiple
            :close-on-select="false"
            :reduce="(data => data.id)"
            :deselect-from-dropdown="true"
          />
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group label="Delivered By">
          <custom-v-select
            v-model="filters.deliveredBy"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="usersList"
            label="fullname"
            placeholder="Select Delivered By"
            multiple
            :close-on-select="false"
            :reduce="(data => data.id)"
            :deselect-from-dropdown="true"
          />
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group label="Delivered Mode">
          <custom-v-select
            v-model="filters.delivery_mode"
            :options="deliveryModeOptions"
            label="text"
            placeholder="Select Delivery Mode"
            multiple
            :close-on-select="false"
            :reduce="data => data.id"
            :deselect-from-dropdown="true"
          />
        </b-form-group>
      </b-col>
      <b-col
        cols="12"
        md="2"
      >
        <b-form-group>
          <b-form-checkbox
            v-model="otpVerifiedCheck"
            name="otp-verified"
            style="margin-top: 1rem"
            :indeterminate="false"
          >
            OTP Verified
          </b-form-checkbox>
          <b-form-checkbox
            v-model="otpNotVerifiedCheck"
            name="otp-not-verified"
            style="margin-top: .5rem"
            :indeterminate="false"
          >
            OTP Not Verified
          </b-form-checkbox>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from 'axios'
import {
  BRow, BCol, BFormInput, BAlert,
  BFormGroup,
  BFormCheckbox,
} from 'bootstrap-vue'
import CustomVSelect from '@/components/UI/CustomVSelect.vue'
import FlatPicker from '@/components/UI/FlatPicker.vue'
import { debounce } from 'lodash'
import { deliveryModeOptions } from '@/utils/consts'

export default {
  components: {
    BRow,
    BCol,
    BFormInput,
    BAlert,
    CustomVSelect,
    BFormGroup,
    FlatPicker,
    BFormCheckbox,
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      errorMessage: '',
      loading: false,
      statusOptions: ['CREATED', 'PICKED', 'DELIVERED'],
      areaOptions: [],
      buyerOptions: [],
      margUsers: [],
      usersList: [],
      deliveryModeOptions,
    }
  },
  computed: {
    filters() {
      return this.$props.value || {}
    },
    billNumber: {
      get() {
        return this.filters.bill_no || ''
      },
      set(newVal) {
        this.updateBillNo(newVal)
      },
    },
    otpVerifiedCheck: {
      get() {
        return this.filters.otpVerified === true
      },
      set(newVal) {
        if (newVal) {
          // When OTP Verified is checked
          this.$emit('input', {
            ...this.filters,
            otpVerified: true,
          })
        } else {
          // When OTP Verified is unchecked
          this.$emit('input', {
            ...this.filters,
            otpVerified: this.otpNotVerifiedCheck ? false : undefined,
          })
        }
      },
    },
    otpNotVerifiedCheck: {
      get() {
        return this.filters.otpVerified === false
      },
      set(newVal) {
        if (newVal) {
          // When OTP Not Verified is checked
          this.$emit('input', {
            ...this.filters,
            otpVerified: false,
          })
        } else {
          // When OTP Not Verified is unchecked
          this.$emit('input', {
            ...this.filters,
            otpVerified: this.otpVerifiedCheck ? true : undefined,
          })
        }
      },
    },
  },
  mounted() {
    this.fetchDeliveryOptions()
  },
  methods: {
    updateBillNo: debounce(function updateBillNo(billNo) {
      this.$emit('input', {
        ...this.filters,
        bill_no: billNo,
      })
    }, 500),
    async fetchDeliveryOptions() {
      try {
        this.loading = true
        const { data: buyersRes } = await axios.get('/accounts/buyers_options')
        this.buyerOptions = buyersRes.data

        const { data: areas } = await axios.get('/accounts/areas_options')
        this.areaOptions = areas.data

        const { data: margUsers } = await axios.get('/accounts/marg_users')
        this.margUsers = margUsers

        const { data: retailer } = await axios.get('/delivery/users_list?retailers_only=true')
        const retailersId = retailer.map(i => i.id)
        const { data: usersList } = await axios.get('/delivery/users_list')
        this.usersList = usersList.filter(user => !retailersId.includes(user.id))
      } catch (error) {
        this.errorMessage = error?.response?.data?.detail || 'Failed to fetch filter options!'
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
